import React, { useState } from 'react';
import { runAdminAccountCreation } from '../utils/createAdminAccounts';

const AdminAccountSetup = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const handleCreateAccounts = async () => {
    setIsCreating(true);
    setShowResults(false);
    
    try {
      const accountResults = await runAdminAccountCreation();
      setResults(accountResults);
      setShowResults(true);
    } catch (error) {
      console.error('Error creating admin accounts:', error);
      setResults([{
        success: false,
        email: 'System Error',
        error: error.message
      }]);
      setShowResults(true);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Super Admin Account Setup
        </h2>
        
        <div className="mb-6">
          <p className="text-gray-600 mb-4">
            This will create the required super admin accounts for the system:
          </p>
          <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
            <li><strong>work.goyalco@gmail.com</strong> - Goyal Co Admin</li>
            <li><strong>avularudrasekharreddy@gmail.com</strong> - Avula Rudra Sekhar Reddy</li>
          </ul>
          <p className="text-sm text-gray-500 mt-4">
            Both accounts will be created with password: <code className="bg-gray-100 px-2 py-1 rounded">goyal@123</code>
          </p>
        </div>

        <button
          onClick={handleCreateAccounts}
          disabled={isCreating}
          className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
        >
          {isCreating ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Creating Accounts...
            </>
          ) : (
            'Create Super Admin Accounts'
          )}
        </button>

        {showResults && (
          <div className="mt-6">
            <h3 className="text-lg font-medium text-gray-900 mb-3">Results:</h3>
            <div className="space-y-3">
              {results.map((result, index) => (
                <div
                  key={index}
                  className={`p-3 rounded-lg border ${
                    result.success
                      ? 'bg-green-50 border-green-200 text-green-800'
                      : 'bg-red-50 border-red-200 text-red-800'
                  }`}
                >
                  <div className="flex items-center">
                    {result.success ? (
                      <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    ) : (
                      <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    )}
                    <div>
                      <p className="font-medium">{result.email}</p>
                      <p className="text-sm">
                        {result.success ? result.message : result.error}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {results.some(r => r.success) && (
              <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-blue-800 text-sm">
                  ✅ Super admin accounts created successfully! You can now sign in with these credentials.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminAccountSetup;
